var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_biz_ote_lbl_addstudent"),
        visible: _vm.isShow,
        size: "960px",
        direction: "rtl",
        "destroy-on-close": true,
        "before-close": function (done) {
          return done(_vm.dialogEdited)
        },
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("select-exam-user", {
        ref: "selector",
        attrs: {
          id: _vm.id,
          groupSelect: _vm.groupSelect,
          functionCode: _vm.functionCode,
          dataPermissionCode: _vm.permissionCode,
          batchId: _vm.batchId,
          projectId: _vm.projectId,
          taskId: _vm.taskId,
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("yxt-button", { attrs: { plain: "" }, on: { click: _vm.hide } }, [
            _vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle"))),
          ]),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }